function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcePoolLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 172",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.612 14.333h86v143.334h-86Z",
    style: {
      fill: "#c5c5c5",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(18.683 6.27) scale(.92708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.778 21.5h71.667v14.333H36.778Zm0 21.5h71.667v14.333H36.778Zm0 21.5h71.667v14.333H36.778Z",
    style: {
      fill: "#909090",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(18.683 6.27) scale(.92708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.695 25.083a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167zm0 21.5a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167zm0 21.5a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167z",
    style: {
      fill: "#76ff03",
      stroke: "none"
    },
    transform: "translate(18.683 6.27) scale(.92708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.507 10.779-23.291 10.75v129l23.291 10.75m102.983-150.5 23.293 10.75v129l-23.292 10.75",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#7a7a7a",
      strokeWidth: 10.74999046,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcePoolLocal);
export default __webpack_public_path__ + "static/media/resourcePoolLocal.b16ee4379e6d639d48dc3f440b7dc520.svg";
export { ForwardRef as ReactComponent };